import z from 'zod';
import { t } from 'i18next';
import { OnboardingFormFields } from '@Types/index.ts';

export const isValidSSN = (ssn: string): boolean => {
  const cleanedSSN = ssn.replace(/-/g, '').replace(/ /g, '').replace(/_/g, '');
  return cleanedSSN.length === 9;
};

export const ssnSchema = z.object({
  [OnboardingFormFields.SSN]: z
    .string()
    .min(1, t('enErrors:required'))
    .refine(isValidSSN, { message: t('enErrors:ssn') }),
});

export const getConditionalSsnSchema = (isUs: boolean) => {
  return isUs
    ? ssnSchema
    : z.object({
        [OnboardingFormFields.SSN]: z.string().optional(),
      });
};
